export { default } from './CompactBrief';
